<!-- TO-DO: We should be announcing with aria-live the page title *I think -->
<sl-impersonate></sl-impersonate>
<app-loading></app-loading>
<div class="app-contents" [class.admin-view]="isAdmin">
  @if (!isAdmin) {
    <app-header></app-header>
  }
  @if (isAdmin) {
    <app-admin-header></app-admin-header>
  }
  <div class="route-content">
    <router-outlet></router-outlet>
  </div>
</div>